import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Space } from "antd";

import {
  Header,
  Nav,
  HamburgerMenu,
  BaseTable,
} from "./components";

import {
  loginUserCheck,
  logoutUser,
  brandFetch,
} from "../redux/actions";

class AdminDocument extends Component {
  constructor() {
    super();
    this.state = {
      isEdit: false,
      toggleMenu: false,
      columns: [
        {
          title: "Image",
          dataIndex: "img",
          key: "img",
          render: (text) => (
            <div>
              <img
                src={text}
                style={{ height: "30px", maxWidth: "100px" }}
                alt="product"
              />
            </div>
          ),
        },
        {
          title: "Brand",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "Created Date",
          dataIndex: "brand_id",
          key: "brand_id",
          render: (text) => {
            const d = new Date(Number(text));
            const date =
              d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            return date;
          },
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle" className="table-action">
              <Button
                type="primary"
                className="btn-edit"
                onClick={() => {
                  window.location = `/admin/documentdetail?id=${record.id}&title=${record.title}`;
                }}
              >
                ดูเอกสาร
              </Button>
            </Space>
          ),
        },
      ],
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    this.props.brandFetch();
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-product">
          <Nav active="document" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>ดาวน์โหลดเอกสาร : ยี่ห้อ</h2>
              </div>
              <div className="info">
                <BaseTable
                  columns={this.state.columns}
                  datas={this.props.brands ? this.props.brands : []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, brand }) => {
  return {
    user: auth.user,
    brands: brand.brands,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  brandFetch,
})(AdminDocument);
